<mat-card appearance="outlined" class="col-12 stretch">
  <div mat-card-header> 1040 Prospector </div>
  <div mat-card-content>
    <img
      src="https://uat.rightbridge.net/cetera/images/Prospector.png"
      alt="1040 Prospector"
    />
    <p>
      Click the button below to start uploading your 1040 clients. Remember that
      you will need to have a completed
      <a
        href="https://uat.rightbridge.net/cetera/docs/DisclosureForm.pdf"
        target="_blank"
      >
        disclosure
      </a>
      for each of your clients.
    </p>
    <form
      action="{{ externalUrl }}"
      ngNoForm
      method="post"
      enctype="multipart/form-data"
    >
      <input value="{{ session }}" type="text" hidden name="X_RB_u" />
      <button mat-raised-button type="submit" color="primary">
        <mat-icon>cloud_upload</mat-icon> Start Uploading
      </button>
    </form>
    <div class="footer w-100">
      <span>Export Instructions:</span>&nbsp;
      <a
        href="https://uat.rightbridge.net/cetera/docs/Lacerte.pdf"
        target="_blank"
      >
        Lacerte
      </a>
      &nbsp;
      <a
        href="https://uat.rightbridge.net/cetera/docs/Drake.pdf"
        target="_blank"
      >
        Drake
      </a>
      &nbsp;
      <a
        href="https://uat.rightbridge.net/cetera/docs/UltraTax.pdf"
        target="_blank"
      >
        UltraTax
      </a>
      &nbsp;
      <a
        href="https://uat.rightbridge.net/cetera/docs/Proseries.pdf"
        target="_blank"
      >
        Proseries
      </a>
    </div>
  </div>
</mat-card>
